import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.XeroAirwallexBatchPaymentForm.DeletedBeneficiariesPopup',
    {
        description1:
            'The following beneficiaries were removed in Airwallex while you have been working with the request:',
        description2:
            'To proceed with the request, please check that no removed beneficiaries are used on the batch lines.',
        ok: 'OK',
        beneficiary: 'Beneficiary',
    }
);
